import {
  observable,
  action,
  computed,
  makeObservable,
  extendObservable,
  autorun,
} from "mobx";
// import { computedFn } from "mobx-utils";

class SubStore {
  constructor(getValueFunction, setValueFunction) {
    extendObservable(
      this,
      {
        get value() {
          return getValueFunction();
        },
        setValue(value) {
          if (setValueFunction) setValueFunction(value);
        },
      },
      {
        value: computed,
        setValue: action,
      }
    );
  }
}

class Message {
  constructor({ from, to, timeStamp, message }) {
    this.from = from;
    this.to = to;
    this.timeStamp = timeStamp;
    this.message = message;
  }
}

class CommuncationStore {
  constructor() {
    this.messages = {};
    this.groups = {};
    this.stores = {};
    this.storeValues = {};
    extendObservable(
      this,
      {
        stores: this.stores,
        storeValues: this.storeValues,
        registerSubstore: this.registerSubstore,
      },
      { stores: observable, storeValues: observable, registerSubstore: action }
    );
    makeObservable(this, {
      messages: observable,
      groups: observable,
      addGroup: action,
      addGroupMember: action,
      // getMessageToID: computed,
      // getMessagesFromTo: computed,
      // getMessagesTo: computed,
      // getMessagesFrom: computed,
      addMessage: action,
      // registerReceiveID: action,
    });
  }

  setRootStore(rootStore) {
    this.rootStore = rootStore;
  }

  registerReceiveID({ to }) {
    if (this.messages[to] === undefined) {
      this.messages[to] = [];
      // extendObservable(this.messages, { to: [] }, { to: observable }); //reichte eventuell so nicht. Eventuell ganze array struktur => subklasse
    }
  }
  addMessage({ from, to, message }) {
    this.registerReceiveID({ to });
    this.messages[to].push(
      new Message({ from, to, message, timeStamp: new Date() })
    );
  }
  addGroup({ groupId, memberIDs = [] } = {}) {
    if (!this.groups[groupId]) {
      this.groups[groupId] = memberIDs; //"all"=>immer alle widgets
    } else {
      this.groups[groupId] = this.groups[groupId].append(
        memberIDs.filter((o) => !this.groups[groupId].includes(o))
      );
    }
  }
  addGroupMember({ groupId, memberId } = {}) {
    if (!this.groups[groupId]) {
      this.addGroup(groupId);
    }
    if (!this.groups[groupId].includes(memberId))
      this.groups[groupId].push(memberId);
  }

  getSorted = ({ messages = [] } = {}) =>
    messages.slice().sort((a, b) => b.timeStamp - a.timeStamp);

  getNewest = ({ messages = [] } = {}) => this.getSorted({ messages })[0];

  getNewestOrFull = ({ messages = [], full = false }) =>
    full ? this.getSorted({ messages }) : this.getNewest({ messages });

  getMessagesToID = ({ toId, full = false, to = toId } = {}) => {
    this.registerReceiveID({ to });
    return this.getNewestOrFull({ messages: this.messages[to], full });
  }; //without Groups

  getGroupsToId = ({ id }) =>
    Object.keys(this.groups).filter((g) => this.groups[g].includes(id));
  // getMessagesFrom({ fromId }) {}

  getMessagesToFull = ({ exclude = false, to } = {}) =>
    exclude
      ? this.getMessagesToID(to)
      : this.getMessagesToID(to).append(
          this.getGroupsToId(to)
            .map((g) => this.getMessagesToID(g))
            .flatten()
        );

  getMessagesTo = ({ exclude = false, to, full = false } = {}) =>
    this.getNewestOrFull({
      messages: this.getMessagesToFull({ to, exclude }),
      full,
    });
  // getMessagesFromTo() {}
  // sendMessage({ from, to, message }) {

  // }
  onReceiveMessage({ to, fun, exclude = false, full = false } = {}) {
    this.registerReceiveID(to);
    autorun(() => fun(this.getMessagesTo({ to, exclude, full })));
  }

  registerStore(store, storeName, subStoreName, valueName, setValueName) {
    this.stores[storeName] = store;
    const keys = Object.keys(store[subStoreName]);
    keys.forEach((k) => {
      this.registerSubstore(store[subStoreName][k], valueName, k, setValueName);
    });
  }

  registerSubstore(store, valueName, key, setValueName) {
    this.storeValues[key] = new SubStore(
      () => {
        return store[valueName];
      },
      (value) => {
        if (setValueName) {
          store[setValueName](value);
        }
      }
    );
    // extendObservable(this, { [key]: this[key] }, { [key]: observable });
  }
}

export default CommuncationStore;
